import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { Store } from '@ngxs/store';
import { map, of, switchMap } from 'rxjs';

import { MultilanguageService } from '@plugins/client/multilanguage/multilanguage.service';

import { LoadInstance } from '../store/instance/instance.actions';
import { InstanceState } from '../store/instance/instance.state';

@Injectable({
  providedIn: 'root',
})
export class InstanceGuard implements CanActivate {
  private store = inject(Store);
  private multilanguageService = inject(MultilanguageService);

  canActivate(route: ActivatedRouteSnapshot) {
    return this.validate();
  }

  private validate() {
    return this.store.selectOnce(InstanceState.instance).pipe(
      switchMap((instance) => {
        if (instance) {
          return of(true);
        }
        return this.store.dispatch(new LoadInstance()).pipe(
          map(() => {
            const instance = this.store.selectSnapshot(InstanceState.instance);
            this.multilanguageService.setLimitedLanguages(instance.languages);
            return true;
          }),
        );
      }),
    );
  }
}
